<template>
  <div>
    <Header title="Solicitação de Turmas" />
    <section class="px-11">
      <div v-if="notFound">
        <NotFound
          :title="'Não encontramos esta solicitação!'"
          btn="Voltar para home"
          :btnFunction="handleGoHome"
          :text="
            'A solicitação não existe. Verifique o link ou entre em contato com a pessoa responsável por ele.'
          "
        />
      </div>
      <div v-else-if="statusReady">
        <!-- ja soliciatado reabertura -->
        <NotFound
          v-if="reopen.value"
          type="ok"
          :title="'Esta solicitação já foi preenchida!'"
          btn="Voltar para home"
          :btnFunction="handleGoHome"
          @click-btn2="handleLogin"
          :text="
            'Mas uma solicitação de reabertura já foi realizada.'
          "
        />

        <NotFound
          v-else-if="notLogged"
          type="ok"
          :title="'Esta solicitação já foi preenchida!'"
          btn="Voltar para home"
          btn2="Fazer Login"
          :btnFunction="handleGoHome"
          @click-btn2="handleLogin"
          :text="
            'Tudo certo! Mas caso não esteja esperando por isso, você poderá solicitar a reabertura desta solicitação. Entre no sistema antes de solicitar.'
          "
        />

        <NotFound
          v-else
          type="ok"
          :title="'Esta solicitação já foi preenchida!'"
          btn="Voltar para home"
          btn2="Solicitar reabertura"
          :loadingBtn2="reopen.loading"
          @click-btn2="requestReopen"
          :btnFunction="handleGoHome"
          :text="
            'Tudo certo! Mas caso não esteja esperando por isso, você poderá solicitar a reabertura desta solicitação clicando no botão abaixo.'
          "
        />
      </div>
      <div v-else-if="notLogged">
        <NotFound
          type="login"
          :title="'Você não está logado!'"
          btn="Fazer Login"
          :btnFunction="handleLogin"
          :text="
            'Você precisa estar logado para acessar a solicitação de turmas.'
          "
        />
      </div>
      <div v-else-if="notAllowed">
        <NotFound
          type="401"
          :title="'Você não tem permissão!'"
          btn="Voltar para home"
          :btnFunction="handleLogin"
          :text="
            'Você não possui permissão para acessar esta página.'
          "
        />
      </div>
      <div v-else-if="loading">
        <p>Carregando...</p>
      </div>
      <div v-else>
        <HandleEditClasses
          :data="classes"
          :data-rooms="rooms"
          :data-room-types="roomTypes"
          :info="info"
          :default_preference_value="default_preference_value"
          @save="send"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import NotFound from "@/components/NotFound.vue";
import HandleEditClasses from "@/handles/paas/ClassesRequests/HandleEditClasses.vue";

import { getRequestInfo } from "@/api/db";
import { loadLoginScreen } from "@/api/oidc.js";
import { reopenRequest, sendPaasClassesRequest } from "@/api/requests";

export default {
  name: "PaasRequestHandle",
  components: {
    Header,
    NotFound,
    HandleEditClasses,
  },
  data() {
    return {
      change: false,
      default_preference_value: 1,
      notFound: false,
      notLogged: false,
      statusReady: false,
      notAllowed: false,
      loading: true,
      selectRooms: {
        list: [],
      },
      info: {
        hash: "",
        status: ""
      },
      reopen: {
        value: false,
        loading: false,
        success: false,
        error: false
      },
      classes: [],
      dialog: {
        open: false
      },
      roomTypes: [],
      rooms: [],
      edit: {
        dialog: false,
        placeholder: {},
        idx: undefined
      },
    };
  },
  methods: {
    handleLogin() {
      this.$store.commit(
        "setRedirect",
        `/paas/solicitacao/${this.info.hash}`
      );
      loadLoginScreen();
    },
    handleGoHome() {
      this.$router.replace({ name: "Home" });
    },
    send(_classes) {
      sendPaasClassesRequest(
        _classes,
        this.info.hash,
      );
      this.$store.dispatch("removeRequestData", {
        hash: this.info.hash
      });
      this.info.status = "Pronto";
      this.statusReady = true;
    },
    requestReopen() {
      this.reopen.loading = true;
      reopenRequest(this.info.hash)
        .then(_ => {
          console.log(_);
          alert("Solicitado com sucesso!");
          this.reopen.value = true;
        })
        .catch(_ => {
          console.log(_);
          alert("Algo deu errado, tente novamente mais tarde.");
        })
        .finally(() => {
          this.reopen.loading = true;
        });
      //console.log('here reabertura')
    }
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Paas"
    });
  },
  async mounted() {
    const hash = this.$route.params.hash;

    this.info.hash = hash;

    const data = await getRequestInfo(hash);
    this.reopen.value = data.reopen_request;

    if (data == "Not Found") this.notFound = true;
    else if (data.request.status == "Pronto") {
      this.statusReady = true;
      this.notLogged = !this.$store.getters.isLoggedIn;
    } else if (!this.$store.getters.isLoggedIn) this.notLogged = true;
    else if (
      !(
        this.$store.getters.userIsStaff ||
        this.$store.getters.userIsAdmin
      )
    ) {
      this.notAllowed = true;
    } else {
      let requests = JSON.parse(
        JSON.stringify(this.$store.getters.getRequestData)
      );
      let found = requests.findIndex(e => e.hash == hash);

      if (found != -1) {
        this.classes = JSON.parse(
          JSON.stringify(requests[found].classes)
        );
        this.selectRooms.list = JSON.parse(
          JSON.stringify(requests[found].rooms)
        );
      } else {
        this.classes = JSON.parse(JSON.stringify(data.classes));
      }

      this.default_preference_value = data?.default_preference ?? 1;

      this.rooms = data.rooms;

      this.info.status = data.request.status;

      this.loading = false;

      if (this.rooms.length > 0) {
        //verify if there is a new roomType
        this.rooms.forEach(e => {
          let idx = this.roomTypes.indexOf(e.tipo);
          if (idx < 0) {
            //add if it is new
            this.roomTypes.push(e.tipo);
          }
          e.all = `${e.bloco} ${e.nome} ${e.tipo}`;
          e.pcd = e.acessivel == 0 ? "-" : "sim";
        });

        if (data.roomsList) {
          data.roomsList.forEach(e => {
            let idx = this.rooms.findIndex(
              el => `${el.bloco} ${el.nome}` == `${e.bloco} ${e.nome}`
            );
            if (idx > -1) this.selectRooms.list.push(this.rooms[idx]);
          });
        }

        // creates a array of preferences with value = 0
        let preferences = this.roomTypes.map(e => {
          return { name: e, value: this.default_preference_value };
        });

        this.classes.forEach(e => {
          e.preferencias =
            e.preferencias.length == 0 ? preferences : e.preferencias;
        });

      }
    }
  }
};
</script>

<style scoped>
.btn {
  float: right;
}

.clear-all {
  width: 100%;
  float: left;
  clear: both;
}

.search {
  max-width: 400px;
}
</style>
